<template>
    <div class="c-input-field">
        <label class="c-input-field__label" :for="name">{{ label }}</label>
        <input :class="'form-field '+ className"
                :name="name"
                :id="name"
                :placeholder="placeholder"
                autocomplete="off"
                type="text"
                v-model.trim="query"
        />
    </div>

</template>

<script>
    import jQuery from 'jquery'
    import Bloodhound from 'corejs-typeahead/dist/bloodhound'
    import typeahead from 'corejs-typeahead/dist/typeahead.jquery';
    import {suggestionsTemplate} from "./SuggestionsHtmlTemplate";
    import Vue from 'vue'

    export default {
        name: "Typeahead",
        props: ['className', 'label', 'name', 'placeholder', 'postType', 'metaQuery', 'preSelectedValue', 'preSelectedSlug'],
        data() {
            return {
                query: this.preSelectedValue,
                suggestions: false
            }
        },
        methods: {
            setupBloodHound() {
                let postType = this.postType
                let metaQuery = this.metaQuery
                let metaValue = this.name

                this.suggestions = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    identify(item) {
                        return item.id
                    },
                    remote: {
                        url: window.ajax.url,
                        replace(url, query) {
                            let queryString ='?action=basethemeTypeahead&postType=' + postType + '&query=' + query;
                            if (metaQuery) {
                                queryString += '&metaKey=' + metaQuery + '&metaValue=' + metaValue;
                            }
                            return url + queryString;
                        },
                        wildcard: '%QUERY',
                        filter(data) {
                            return data;
                        }
                    }
                })
            },
            inputTypeaheadSetup() {
                let element = '.' + this.className
                let $input = jQuery(element)
                let templates = {
                    notFound: '<div class="no-suggestions">Nothing found</div>',
                    pending:  '<div class="loader">Fetching...</div>',
                    suggestion: this.parseSuggestionTemplate
                }

                $input.typeahead({
                        minLength: 3,
                        highlight: true,
                    },
                    {
                        name: 'suggestions',
                        source: this.suggestions,
                        limit: 5,
                        templates: templates
                    })

                $input.on('typeahead:select', (ev, suggestion) => {
                    this.query = suggestion.title
                    $input.typeahead('val', this.query)
                });
            },
            parseSuggestionTemplate(data) {
                let res = Vue.compile(suggestionsTemplate);

                let vm = new Vue({
                    data() {
                        return {
                            result: data
                        }
                    },
                    render: res.render,
                    staticRenderFns: res.staticRenderFns
                }).$mount();

                return vm.$el;
            }
        },
        mounted() {
            this.setupBloodHound()
            this.inputTypeaheadSetup()
        },
    }
</script>

<style scoped>

</style>
